import { useContext, useMemo } from "react"
import { userContext } from "../../shared/context/userContext"

export function useDisplayParticipants(participantList, owner) {
  const { currentUser } = useContext(userContext)

  return useMemo(() => {
    const users = owner?.users
    const roles = owner?.roles

    return (participantList ?? [])
      .filter(p => p.user_id !== currentUser)
      .map(p => {
        const label =
          users?.[p.user_id]?.name ??
          roles?.[p.role]?.display_select

        if (!label) return null

        return {
          label,
          role: p.role,
          isUser: Boolean(p.user_id),
        }
      })
      .filter(Boolean)
  }, [participantList, currentUser, owner?.users, owner?.roles])
}
